export enum PhoneTypes {
    home = 254,
    mobile = 255,
    office = 256,
    other = 257
}